import { angleViews } from '@/mocks/home';

const toneMap: Record<string, { bar: string; dot: string; label: string }> = {
  primary: { bar: 'bg-primary-500', dot: 'bg-primary-500', label: 'text-primary-700' },
  secondary: { bar: 'bg-secondary-500', dot: 'bg-secondary-500', label: 'text-secondary-700' },
  accent: { bar: 'bg-accent-500', dot: 'bg-accent-500', label: 'text-accent-700' },
};

export default function AngleCompare() {
  return (
    <section id="angles" className="bg-background-100 py-10 md:py-16 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-[0.2em] text-primary-600 uppercase">Multiple Angles</span>
          <h2 className="mt-1.5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">同一件事，三种说法</h2>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
            不替任何一方下结论，只把各方的核心主张并列出来，方便你对照着看哪个说法有材料支撑。
          </p>
        </div>

        <div className="mt-7 md:mt-9 grid md:grid-cols-3 gap-4 md:gap-5">
          {angleViews.map((view) => {
            const tone = toneMap[view.tone] ?? toneMap.secondary;
            return (
              <article key={view.side} className="rounded-lg border border-background-200 bg-background-50 p-5 flex flex-col">
                <span className={`h-1 w-12 rounded-full ${tone.bar}`}></span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{view.side}</h3>
                <ul className="mt-4 space-y-3">
                  {view.points.map((point) => (
                    <li key={point} className="flex gap-2.5 text-sm text-foreground-600 leading-relaxed">
                      <span className={`mt-1.5 w-1.5 h-1.5 rounded-full shrink-0 ${tone.dot}`}></span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-auto pt-5">
                  <span className={`inline-flex items-center gap-1.5 text-xs font-label ${tone.label}`}>
                    <i className="ri-shield-check-line"></i>
                    已标注信息来源
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}